import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "settings-users-container mb-10 pb-10" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Subscription Details")
], -1)
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "nav nav-tabs nav-line-tabs mb-5 fs-6" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = {
  class: "tab-content",
  id: "subscriptionTab"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navigator = _resolveComponent("Navigator")!
  const _component_Subscription = _resolveComponent("Subscription")!
  const _component_Invoices = _resolveComponent("Invoices")!
  const _component_Transactions = _resolveComponent("Transactions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navigator, {
      to: "/settings",
      text: "Back to settings"
    }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", _hoisted_6, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link", {
                active: _ctx.currentTab === 'subscriptions',
              }]),
              "data-bs-toggle": "subscriptions",
              href: "javascript:void(0)",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setTab('subscriptions')))
            }, " Subscription ", 2)
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link", {
                active: _ctx.currentTab === 'invoices',
              }]),
              "data-bs-toggle": "invoices",
              href: "javascript:void(0)",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setTab('invoices')))
            }, "Invoices", 2)
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link", {
                active: _ctx.currentTab === 'transactions',
              }]),
              "data-bs-toggle": "transactions",
              href: "javascript:void(0)",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setTab('transactions')))
            }, "Transactions", 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: _normalizeClass(["tab-pane fade", {
              active: _ctx.currentTab === 'subscriptions',
              show: _ctx.currentTab === 'subscriptions',
            }]),
            id: "subscription"
          }, [
            (_ctx.currentTab === 'subscriptions')
              ? (_openBlock(), _createBlock(_component_Subscription, { key: "subscriptions" }))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["tab-pane fade", {
              active: _ctx.currentTab === 'invoices',
              show: _ctx.currentTab === 'invoices',
            }]),
            id: "invoices"
          }, [
            (_ctx.currentTab === 'invoices')
              ? (_openBlock(), _createBlock(_component_Invoices, { key: "invoices" }))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["tab-pane fade", {
              active: _ctx.currentTab === 'transactions',
              show: _ctx.currentTab === 'transactions',
            }]),
            id: "transactions"
          }, [
            (_ctx.currentTab === 'transactions')
              ? (_openBlock(), _createBlock(_component_Transactions, { key: "transactions" }))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ])
    ])
  ]))
}